<template>
    <div class="rhythmClass">
        <el-col :span="24" class="zhiAudio" align="left" v-if="heart.questionDto.detailInfo.audioUrl">
            <audio-style 
                style="width:180px;float:left"
                ref="audioRef"
                @startPlaying="startPlaying"
                @endPlaying="endPlaying"
                @getPlays="getPlays"
                :styleText="'请点击播放'"
                :audioUrl="heart.questionDto.detailInfo.audioUrl"
                class="audioCom"
            ></audio-style>
            <div class="playNum" v-if="heart.questionDto.detailInfo.playTime!=-1">
                <div class="playNumIng"><img src="./../../../static/images/play.png" alt="" srcset=""></div>
                {{`X${plays}`}}
            </div>
        </el-col>
        <el-col :span="24" class="explainText" v-if="heart.questionDto.detailInfo.audioUrl">
            点击音频部分播放，选择正确答案
        </el-col>
        <el-col :span="24" class="imgStyle" align="left">
            <div class="optionsHaveValue">
                <div v-for="(item,i) in forInput" :key="i">
                    <el-input v-model='item.fillBlankVal' @change="outputFillBlankVal" :placeholder="'请输入答案'+Number(i+1)" :class="item.color? 'tkStyle_green':'tkStyle_red'"></el-input>
                    <div :class="item.color? 'hook-dui':'hook-cuo'"></div>
                </div>
            </div>
        </el-col>
    </div>
</template>
<script>
import audioStyle from '../../components/audioStyle'
import utils from '../../lib/util'
    export default {
        name:"fillBlanks",
        props: {
            sonData: Object,
        },
        data() {
            return {
                heart:{
                    questionDto:{
                        detailInfo:{}
                    }
                },
                rhythmBeatVal:[],
                timeHer:'',
                advancedRadio:[],
                plays:0,
                forInput:[],
                valueComple:'',
            }
        },
        components:{
            audioStyle
        },
        watch: {},
        computed:{},
        created(){},
        mounted(){
            this.heart = this.sonData
            this.$nextTick(function(){
                this.rhythmBeatVal = []
                this.plays = utils.mottoClone(this.heart.questionDto.detailInfo.playTime)

                this.forInput = []
                this.heart.questionDto.detailInfo.blankList.forEach((ele,index) => {
                    this.forInput.push({
                        fillBlankVal:ele,
                        color:ele==this.sonData.errorObj.fillBlankVal? this.sonData.errorObj.fillBlankVal.split('#@#')[index]? true:false:false
                    })
                });

                
            })
        },
        methods:{
            getPlays(){
                //限定播放次数
                this.$refs.audioRef.fatherPlay(this.plays,this.heart.questionDto.detailInfo.playTime)
            },
            startPlaying(){
                
            },
            endPlaying(){
                if(this.plays<=0) this.plays=0
                else this.plays--;
            },
            yesNotProblem(){
                let fleg = false
                this.forInput.forEach((son,i) => {
                    if(son.fillBlankVal){
                        fleg = true;
                        return 
                    }
                });
                if(fleg) return true
                return false
            },
            // 数据转化为 #@#
            outputFillBlankVal(){
                this.valueComple = ''
                this.forInput.forEach((son,i) => {
                    this.valueComple += i==0? (son.fillBlankVal? son.fillBlankVal:' '):'#@#'+(son.fillBlankVal? son.fillBlankVal:' ')
                });
            },
            endAudio(){
                if(!this.heart.questionDto.detailInfo.audioUrl) return
                if(!this.$refs.audioRef.judgePaying()){
                    this.endPlaying()
                }
                this.$refs.audioRef.endAudio()
            },
        }
    }
</script>
<style scoped lang="less">
    .rhythmClass{
        height: 100%;
        width: 100%;
        .zhiAudio{
            height: 33px;
            width: 100%;
            box-sizing: border-box;
            padding-left: 16px;
            .playNum{
                float: left;
                display: inline-block;
                height: 33px;
                width: 100px;
                .playNumIng{
                    display: inline-block;
                    img{
                        margin: 5px 0 0 15px;
                        vertical-align: text-bottom;
                    }
                }
            }
        }
        .explainText{
            box-sizing: border-box;
            padding:5px 0 0 16px;
            text-align: left;
            font-size: 12px;
            color: #A0A1A0;
        }
        .imgStyle{
            width: 100%;
            height: 100%;
            box-sizing: border-box;
            padding: 10px 18px;
            .optionsHaveValue{
                height: 100%;
                overflow-y: auto;
                // pointer-events: none;
            }
        }
    }
    .hook-dui{
        height: 15px;
        width: 15px;
        margin-top: 17px;
        margin-left: 5px;
        float: left;
        background-image: url('../../../static/images/dui.png');
        background-repeat: no-repeat;
        background-size: 100% 100%;
    }
    .hook-cuo{
        height: 15px;
        width: 15px;
        margin-top: 17px;
        margin-left: 5px;
        float: left;
        background-image: url('../../../static/images/cuo.png');
        background-repeat: no-repeat;
        background-size: 100% 100%;
    }
</style>
<style>
    .styleCent .el-radio__inner{
        height: 18px;
        width: 18px;
    }
    .textAlign .tableimg{
        height: 37px;
        max-height: 37px !important;
        width: 80% !important;

        position: relative;
        display: inline-block;
        vertical-align: middle;
    }
    .textAlign .tableimg img{
        max-width: 100%;
        max-height: 100%;
        position: absolute;
        top: 0;
        /* right: 0; */
        bottom: 0;
        left: 0;
        display: block;
        margin: auto 0;
    }
    .tkStyle_red
    ,tkStyle_green{
        margin: 5px 0;
        width: 95%;
        float: left;
    }
    .tkStyle_red .el-input__inner{
        color: red !important;
    }
    .tkStyle_green .el-input__inner{
        color: green !important;
    }
</style>


// WEBPACK FOOTER //
// src/components/examRecords/fillBlanks.vue